/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/alt-text */
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Card, Form, Button, InputGroup, Image } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { useDispatch, useSelector } from "react-redux";
import * as actionsArticles from "../../../../redux/actions/artciles";
import { fetchSearch } from "../../../../redux/actions/users";
import { peoplePlaceHolder } from "../../../components/imageUserDefault";
import ReactMde from "react-mde";
import ReactMarkdown from "react-markdown";
import "react-mde/lib/styles/css/react-mde-all.css";
import { Route } from "react-router-dom";
import PollCreatorDialog from "./PollCreatorDialog";
import * as Yup from "yup";
import { fetchImageToken } from "../../../../redux/actions/imageAuth";
import { articlesSlice } from "../../../../redux/actions/artciles/articlesSlice";
import SelectGif from "../RestlessPostEditor/SelectGif";
import { getGifById } from "../../../components/GIPHY";
import "./style.css";

const { actions } = articlesSlice;

export default function RestlessArticlesEditorPage({ history, match }) {
  const dispatch = useDispatch();
  const [selectedTab, setSelectedTab] = useState("write");
  const [featuredImage, setFeaturedImage] = useState(null);
  const [featuredImageError, setFeaturedImageError] = useState(false);
  const [extraVideo, setExtraVideo] = useState(null);
  const [extraImage, setExtraImage] = useState([]);
  const [anotherAuthorImage, setAnotherAuthorImage] = useState(null);
  const [resourceRestlessAuthor, setResourceRestlessAuthor] = useState(null);
  const [writingSearch, setWritingSearch] = useState(false);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [userSearch, setUserSearch] = useState("");
  const [errorSearch, setErrorSearch] = useState();
  const [errorMessage, setErrorMessage] = useState();
  const [fetchedPoll, setFetchedPoll] = useState(null);
  const { id } = match.params;

  const isAddMode = !id;

  const MAX_MARKDOWN_CHARACTERS = 15000;

  const {
    categoriesList,
    poll,
    articleLoading,
    articleGet,
    imageToken,
    articleCreating,
    articleCreated,
    articleUpdated,
    suggestedPeople,
    error,
  } = useSelector((state) => ({
    categoriesList: state.articles.categoriesList,
    poll: state.articles.poll,
    articleLoading: state.articles.articleLoading,
    articleGet: state.articles.articleGet,
    imageToken: state.imageAuth.imageToken,
    articleCreating: state.articles.articleCreating,
    articleCreated: state.articles.articleCreated,
    articleUpdated: state.articles.articleUpdated,
    suggestedPeople: state.users2.usersList,
    error: state.articles.error,
  }));

  useEffect(() => {
    dispatch(actionsArticles.fetchCategories());
    if (id) dispatch(actionsArticles.fetchArticle(id));
    dispatch(fetchImageToken());
    return () => {
      cleanState();
      if (articleGet) {
        dispatch(actions.articleFetched({ articleGet: null }));
      }
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const mediaType = ["None", "Images", "Video", "Gif", "Poll"];
  const [extraGif, setExtraGif] = useState();
  const [articleToEdit, setArticleToEdit] = useState(false);
  const initialValues = {
    title: "",
    stand_first: "",
    content: "",
    category: "",
    featuredImage: null,
    author: null,
    anotherAuthor: "",
    anotherAuthorImage: null,
    restlessUserSearch: "",
    mediaContent: "",
  };

  const authors = ["Custom user", "Restless user"];

  const ArticleSchema = Yup.object().shape({
    title: Yup.string()
      .max(50, "Maximum 50 characters")
      .required("Required field"),
    stand_first: Yup.string()
      .max(100, "Maximum 100 characters")
      .optional(),
    content: Yup.string()
      .max(MAX_MARKDOWN_CHARACTERS, "Maximum 15000 Characters")
      .required(),
    category: Yup.string().required(),
    featuredImage: Yup.mixed().required(),
    author: Yup.mixed().required(),
    restlessUserSearch: Yup.string(),
  });

  useEffect(() => {
    if ((articleUpdated || articleCreated) && !articleCreating) {
      history.push("/articles");
      cleanState();
      if (articleGet) {
        dispatch(actions.articleFetched({ articleGet: null }));
      }
    }
  }, [articleUpdated, articleCreated, articleCreating]);

  const cleanState = () => {
    setFeaturedImage(null);
    setFeaturedImageError(false);
    setExtraVideo(null);
    setExtraImage([]);
    setAnotherAuthorImage(null);
    setResourceRestlessAuthor(null);
    setWritingSearch(false);
    setLoadingSearch(false);
    setUserSearch("");
    setErrorSearch();
    setErrorMessage();
    setFetchedPoll(null);
    dispatch(actionsArticles.createPoll(undefined));
  };

  const articlesUIEvents = {
    openPollCreatorDialog: () => {
      history.push({
        pathname: `/articles/new/poll`,        
        state: { poll: poll ? poll : fetchedPoll },
      });
    },
    openSelecGifDialog: () => {
      history.push({
        pathname: articleGet
          ? `/articles/${id}/editor/selectgif`
          : "/articles/new/selectgif",
      });
    },
  };
  const onDeleteGif = () => {
    setExtraGif();
  };
  const onExtraImageChange = (e) => {
    if(e.target.files.length){
      if (extraImage?.length >= 10) {
        setErrorMessage("A maximum of 10 images is allowed");
        return;
      }
      setExtraImage([...extraImage, e.target.files[0]]);
    }
  };

  const onExtraVideoChange = (e) => {
    setExtraVideo(e.target.files[0]);
  };

  const onAnotherAuthorImageChange = (e) => {
    setAnotherAuthorImage(e.target.files[0]);
  };

  const getInputClasses = (fieldname, touched, errors) => {
    if (touched[fieldname] && errors[fieldname]) {
      return "is-invalid";
    }
    return "";
  };

  const onSubmit = (values, { setSubmitting, resetForm }) => {
    // When button submits form and form is in the process of submitting, submit button is disabled
    setSubmitting(true);
    if (!featuredImage) {
      setFeaturedImageError("empty");
      return;
    }


    if (values.author === "Custom user" && !values.anotherAuthor) {
      setErrorMessage("Please set an author manually for the resource");
      return;
    }
    if (
      values.content === "" ||
      !values.content 
    ) {
      setErrorMessage("You can't create empty article");
      return;
    }

    if (values.title === "" || !values.title || !values.title.trim()) {
      setErrorMessage("You can't create article with title empty ");
      return;
    }

    if (values.author === "Restless user" && !values.restlessUserSearch) {
      setErrorMessage("Please set a restless author for the resource");
      return;
    }

    if (values.anotherAuthor && values.restlessUserSearch) {
      setErrorMessage("Resource can only have 1 author");
      return;
    }

    if (!values.anotherAuthor && !values.restlessUserSearch) {
      setErrorMessage("Please set an author for the resource");
      return;
    }
    const formData = new FormData();
    formData.append("lead_image", featuredImage);
    if (extraVideo) formData.append("files", extraVideo);

    extraImage.map((imageFile) => formData.append("files", imageFile));
    if (anotherAuthorImage)
      formData.append("another_author_image", anotherAuthorImage);
    if (anotherAuthorImage === undefined)
      formData.append("another_author_image", null);

    formData.append(
      "article",
      JSON.stringify({
        title: values.title,
        stand_first: values.stand_first,
        body: values.content,
        categoryId: values.category,
        gif_id: extraGif ? extraGif?.id : null,
        poll: poll
          ? {
              ...poll,
              options: poll.options.map((option) => option.value),
            }
          : fetchedPoll
          ? {
              ...fetchedPoll,
              options: fetchedPoll.options.map((option) => option.description),
            }
          : null,
        another_author:
          values.anotherAuthor && !resourceRestlessAuthor
            ? values.anotherAuthor
            : null,
        author_restless_user:
          resourceRestlessAuthor && !values.anotherAuthor
            ? resourceRestlessAuthor.id
            : null,
      })
    );
    if (isAddMode) {
      dispatch(actionsArticles.postArticle(formData));
    } else {
      dispatch(actionsArticles.updateArticle(formData, id));
    }
    setSubmitting(false);
  };

  const setUserSuggestor = (keyword) => {
    if (keyword === undefined || keyword === "") {
      setErrorSearch("The field is empty");
      return;
    } else if (keyword != "") {
      setLoadingSearch(true);
      fetchSearch(keyword, dispatch);
      setWritingSearch(true);
      setErrorSearch();
    }
  };

  const onPressCancel = () => {
    history.push("/articles");
    cleanState();
    if (articleGet) {
      dispatch(actions.articleFetched({ articleGet: null }));
    }
  };

  const onPressUser = (user) => {
    setResourceRestlessAuthor(user);
    setWritingSearch(false);
  };

  const showVideoPreview = (data) => {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center mb-2">
        <div className="mr-2">
          <video controls width="250">
            {articleGet && data?.url ? (
              <source src={data.url + imageToken} />
            ) : (
              <source src={URL.createObjectURL(data)} />
            )}
          </video>
        </div>
        <Button onClick={() => setExtraVideo()}>Remove</Button>
      </div>
    );
  };

  const deleteImage = (index) => {
    const dataImage = new Array(...extraImage);
    if (index) {
      dataImage.splice(index, 1);
    } else {
      dataImage.pop();
    }
    setExtraImage(dataImage);
  };

  const showImagePreview = (data) => {
    return (
      <>
        <div className="d-flex justify-content-center flex-wrap">
          {data?.map(
            (file, index) =>
              file && (
                <div className="mr-2 mt-2">
                  {articleGet && file.url ? (
                    <img
                      alt="attached archive to resource"
                      src={file.url + imageToken}
                      width="45"
                      height="45"
                      onClick={() => deleteImage(index)}
                    />
                  ) : (
                    <img
                      alt="attached archive to resource"
                      src={URL.createObjectURL(file)}
                      width="45"
                      height="45"
                      onClick={() => deleteImage(index)}
                    />
                  )}
                </div>
              )
          )}
        </div>
        <div className="d-flex justify-content-center mt-2 mb-2">
          <Button onClick={() => deleteImage()}>Remove</Button>
        </div>
      </>
    );
  };

  const showImageLeadImage = (data) => {
    return (
      <>
        <div className="d-flex justify-content-center flex-wrap">
          <div className="mr-2 mt-2">
            {articleGet && data.url ? (
              <img
                alt="attached archive to resource"
                src={data?.url + imageToken}
                height="100"
              />
            ) : data ? (
              <img
                alt="attached archive to resource"
                src={URL.createObjectURL(data)}
                height="100"
              />
            ) : null}
          </div>
        </div>
      </>
    );
  };

  const renderSearch = (item) => {
    return (
      <div
        key={item.id}
        className="mt-5"
        style={{
          height: "20px",
          marginBottom: "2em",
          alignContent: "start",
        }}
      >
        <Button onClick={() => onPressUser(item)} style={{ width: "100%" }}>
          <div className="d-flex flex-row justify-content-between">
            <div uppercase={false} className="d-flex flex-column">
              <div
                style={{
                  textAlign: "left",
                  width: "150px",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  display: "block",
                }}
                className="custom-cell-ellipsis"
                title={item.full_name}
              >
                {item.full_name}
              </div>
              <div
                style={{
                  textAlign: "left",
                  fontSize: "0.9rem",
                  width: "150px",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  display: "block",
                }}
                className="custom-cell-ellipsis"
                title={item.email}
              >
                {item.email}
              </div>
            </div>
            {item.picture && (
              <Image
                className="mr-2 mt-2"
                alt="error"
                style={{
                  height: "30px",
                  width: "30px",
                  marginRight: 6,
                  alignSelf: "center",
                }}
                src={item.picture.url + imageToken}
              />
            )}
            {!item.picture && (
              <div
                className="svg-icon svg-icon-lg"
                style={{ alignSelf: "center" }}
              >
                <SVG height="45" src={peoplePlaceHolder} />
              </div>
            )}
          </div>
        </Button>
      </div>
    );
  };

  return (
    <>
      <Route path="/articles/new/poll">
        {({ history, match }) => (
          <PollCreatorDialog
            show={match != null}
            id={match && match.params.id}
            poll={history.location.state?.poll}            
            onHide={() => {
              history.goBack();
            }}
          />
        )}
      </Route>
      <Route
        path={
          articleGet
            ? `/articles/${id}/editor/selectgif`
            : "/articles/new/selectgif"
        }
      >
        {({ history, match }) => (
          <SelectGif
            show={match != null}
            id={match && match.params.id}
            setExtraGif={(data) => setExtraGif(data)}
            extraGif={extraGif}
            onHide={() => {
              history.goBack();
            }}
          />
        )}
      </Route>
      <Formik
        initialValues={initialValues}
        validationSchema={ArticleSchema}
        onSubmit={onSubmit}
      >
        {function Render({
          values,
          errors,
          touched,
          status,
          handleChange,
          handleSubmit,
          setFieldValue,
          getFieldProps,
        }) {
          useEffect(() => {
            if (!isAddMode && !articleLoading && articleGet) {
              setArticleToEdit(true);
              setFieldValue("title", articleGet["title"], false);
              setFieldValue("stand_first", articleGet["stand_first"], false);
              setFieldValue("content", articleGet["body"], false);
              setFieldValue("category", articleGet["category"].id, false);
              setFieldValue(
                "anotherAuthor",
                articleGet["another_author"],
                false
              );
              setFieldValue(
                "restlessUserSearch",
                articleGet["author_restless_user"]?.full_name,
                false
              );

              setResourceRestlessAuthor(articleGet["author_restless_user"]);
              if (articleGet["another_author_image"]) {
                setAnotherAuthorImage(articleGet["another_author_image"]);
                setFieldValue(
                  "anotherAuthorImage",
                  articleGet["another_author_image"]
                );
              }
              if (articleGet["lead_image"]) {
                setFeaturedImage(articleGet["lead_image"]);
                setFieldValue("featuredImage", articleGet["lead_image"]);
              }

              if (articleGet.picture_images.length > 0) {
                setExtraImage(articleGet["picture_images"]);
                setFieldValue("mediaContent", "Images");
              }
              const authorType = articleGet["another_author"]
                ? "Custom user"
                : "Restless user";
              setFieldValue("author", authorType, false);
              if (articleGet.video) {
                setExtraVideo(articleGet["video"]);
                setFieldValue("mediaContent", "Video");
              }
              if (articleGet.poll) {
                setFetchedPoll(articleGet["poll"]);
                setFieldValue("mediaContent", "Poll");
              }
              if (articleGet.gif_id) {
                getGifById(articleGet.gif_id).then((response) => {
                  setExtraGif(response);
                  setFieldValue("mediaContent", "Gif");
                });
              }
            }
          }, [articleGet]); // eslint-disable-line react-hooks/exhaustive-deps

          useEffect(() => {
            setUserSearch(values.restlessUserSearch);
          }, [values.restlessUserSearch]);

          useEffect(() => {
            setFieldValue(
              "restlessUserSearch",
              resourceRestlessAuthor?.full_name,
              false
            );
          }, [resourceRestlessAuthor]);

          useEffect(() => {
            if (values.restlessUserSearch == "") {
              setResourceRestlessAuthor(null);
            }
          }, [values.restlessUserSearch]);

          useEffect(() => {
            if (suggestedPeople?.length > 0) {
              setLoadingSearch(false);
              setErrorMessage("");
            } else if (suggestedPeople?.length == 0 && loadingSearch) {
              setErrorMessage("User not found");
              setLoadingSearch(false);
            }
          }, [suggestedPeople]);

          useEffect(() => {
            if (!articleToEdit) {
              setExtraGif();
              setExtraImage([]);
              setExtraVideo();
              dispatch(actions.articleRemovePoll());
            } else {
              setArticleToEdit(false);
            }
          }, [values.mediaContent]);

          useEffect(() => {
            if (values.author == "Custom user") {
              setFieldValue("restlessUserSearch", "", false);
            }
            if (values.author == "Restless user") {
              setFieldValue("anotherAuthor", "", false);
              setAnotherAuthorImage();
            }
          }, [setFieldValue, values.author]);

          const handleFileInput = (e) => {
            const file = e.target.files[0];

            if (file.type === "image/jpeg" || file.type === "image/png") {
              setFeaturedImage(file);
              setFeaturedImageError(false);
              setFieldValue("featuredImage", e.target.files[0]);
            } else {
              setFeaturedImageError("format");
            }
          };

          const handlePreventDefault = (e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              return;
            }
          };

          const userSuggestions = (
            <div
              className="d-flex justify-content-center align-items-center row mb-2"
              className="scroll"
              style={{
                height: "200px",
                display: "flex",
                flexDirection: "column",
                overflowY: "scroll",
              }}
            >
              {suggestedPeople?.map((item, index) => {
                return (
                  <div keyExtractor={(item, index) => index.toString()}>
                    {renderSearch(item)}
                  </div>
                );
              })}
            </div>
          );
          return (
            <>
              {error && (
                <div className="mb-10 justify-content-center alert alert-custom alert-light-danger alert-dismissible">
                  <div className="alert-text font-weight-bold text-center">
                    {error}
                  </div>
                </div>
              )}
              {errorMessage && (
                <div className="mb-10 justify-content-center alert alert-custom alert-light-danger alert-dismissible">
                  <div className="alert-text font-weight-bold text-center">
                    {errorMessage}
                  </div>
                </div>
              )}
              {!isAddMode && articleLoading ? (
                <div className="d-flex justify-content-center align-content-center">
                  <span className="mx-3 spinner spinner-primary"></span>
                </div>
              ) : (
                <Form onSubmit={handleSubmit}>
                  {status ? (
                    <div className="mb-10 justify-content-center alert alert-custom alert-light-danger alert-dismissible">
                      <div className="alert-text font-weight-bold text-center">
                        {status}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="d-flex">
                    <div className="w-75">
                      <Card>
                        <Card.Body>
                          <Form.Group controlId="formTitle">
                            <div className="d-flex justify-content-end mb-2">
                              <div className="ml-2">
                                <Button
                                  variant="primary"
                                  onClick={() => onPressCancel()}
                                  type="submit"
                                >
                                  Cancel
                                </Button>
                              </div>
                            </div>
                            <Form.Label>Title</Form.Label>
                            <Form.Control
                              type="text"
                              name="title"
                              placeholder="Type a nice title"
                              onChange={handleChange}
                              value={values.title}
                              onKeyDown={(e) => handlePreventDefault(e)}
                              className={getInputClasses(
                                "title",
                                touched,
                                errors
                              )}
                              {...getFieldProps("title")}
                            />
                            {touched.title && errors.title ? (
                              <div className="fv-plugins-message-container">
                                <div className="fv-help-block">
                                  {errors.title}
                                </div>
                              </div>
                            ) : null}
                          </Form.Group>
                          <Form.Group controlId="formDescription">
                            <Form.Label>Stand first</Form.Label>
                            <Form.Control
                              as="textarea"
                              name="stand_first"
                              type="text"
                              placeholder="Type a stand first"
                              onChange={handleChange}
                              value={values.stand_first}
                              className={getInputClasses(
                                "stand_first",
                                touched,
                                errors
                              )}
                              {...getFieldProps("stand_first")}
                              rows="3"
                            />
                            {touched.stand_first && errors.stand_first ? (
                              <div className="fv-plugins-message-container">
                                <div className="fv-help-block">
                                  {errors.stand_first}
                                </div>
                              </div>
                            ) : null}
                          </Form.Group>
                          <Form.Group controlId="formArticle">
                            <Form.Label>Article Content</Form.Label>
                            <div
                              style={{
                                border:
                                  touched.content && errors.content
                                    ? "1px solid red"
                                    : "none",
                              }}
                            >
                              <ReactMde
                                name="content"
                                value={(poll || fetchedPoll) ? (poll? poll.body : fetchedPoll.body) : values.content}
                                readOnly={poll || fetchedPoll}                                
                                onChange={(e) => {
                                  return setFieldValue("content", e);
                                }}
                                selectedTab={selectedTab}
                                onTabChange={setSelectedTab}
                                generateMarkdownPreview={(markdown) =>
                                  Promise.resolve(
                                    <ReactMarkdown children={markdown} />
                                  )
                                }
                                childProps={{
                                  writeButton: {
                                    tabIndex: -1,
                                  },
                                }}
                              />
                            </div>
                            <div className="d-flex justify-content-end">
                              {values.content?.length}/{MAX_MARKDOWN_CHARACTERS}
                            </div>
                            {touched.content && errors.content ? (
                              <div className="fv-plugins-message-container">
                                <div className="fv-help-block">
                                  {errors.content}
                                </div>
                              </div>
                            ) : null}
                          </Form.Group>
                          <Button
                            variant="primary"
                            onClick={handleSubmit}
                            disabled={articleCreating}
                            type="submit"
                            className="mr-3"
                            size="lg"
                          >
                            Submit
                            {articleCreating && (
                              <span className="ml-3 mr-3 spinner spinner-white"></span>
                            )}
                          </Button>
                        </Card.Body>
                      </Card>
                    </div>
                    <div className="ml-5 w-25">
                      <Card>
                        <Card.Body>
                          <Form.Group>
                            <Form.Label>Author</Form.Label>
                            <Form.Control
                              as="select"
                              name="author"
                              defaultValue
                              onChange={handleChange}
                              value={values.author}
                              {...getFieldProps("author")}
                            >
                              {!values.author && (
                                <option>Select an author</option>
                              )}
                              {authors.map((a, index) => (
                                <>
                                  <option key={index.toString()} value={a}>
                                    {a}
                                  </option>
                                </>
                              ))}
                            </Form.Control>
                            {touched.author && errors.author ? (
                              <div className="fv-plugins-message-container">
                                <div className="fv-help-block">
                                  {errors.author}
                                </div>
                              </div>
                            ) : null}
                            {values.author == "Custom user" && (
                              <Form.Group controlId="anotherAuthor">
                                <Form.Label className="mt-5">
                                  Display Name
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="anotherAuthor"
                                  placeholder="Name Last name"
                                  onChange={handleChange}
                                  onKeyDown={(e) => handlePreventDefault(e)}
                                  {...getFieldProps("anotherAuthor")}
                                ></Form.Control>
                                <Form.Label className="mt-5">
                                  Display Image
                                </Form.Label>
                                <Form.File
                                  type="file"
                                  onChange={onAnotherAuthorImageChange}
                                  name="anotherAuthorImage"
                                  label="Select an image"
                                  custom
                                />
                                {anotherAuthorImage &&
                                  showImageLeadImage(anotherAuthorImage)}
                              </Form.Group>
                            )}
                            {anotherAuthorImage &&
                              values.author == "Custom user" && (
                                <div className="d-flex justify-content-center">
                                  <Button
                                    onClick={() => setAnotherAuthorImage()}
                                  >
                                    Clear
                                  </Button>
                                </div>
                              )}
                            {values.author == "Restless user" && (
                              <Form.Group controlId="restlessUserSearch">
                                <Form.Label className="mt-5">
                                  Search a user
                                </Form.Label>
                                <InputGroup className="mb-3">
                                  <Form.Control
                                    type="text"
                                    name="restlessUserSearch"
                                    placeholder={"Name, Last name"}
                                    onChange={handleChange}
                                    onKeyDown={(e) => handlePreventDefault(e)}
                                    value={
                                      !resourceRestlessAuthor
                                        ? values.restlessUserSearch
                                        : resourceRestlessAuthor.full_name
                                    }
                                    {...getFieldProps("restlessUserSearch")}
                                  />
                                  <div className="mb-2">
                                    <Button
                                      className="btn btn-icon btn-primary"
                                      variant="primary"
                                      onClick={() =>
                                        setUserSuggestor(userSearch)
                                      }
                                    >
                                      <span className="svg-icon svg-icon-md">
                                        <SVG
                                          height="50"
                                          src={toAbsoluteUrl(
                                            "/media/svg/icons/General/Search.svg"
                                          )}
                                        />
                                      </span>
                                    </Button>
                                  </div>
                                </InputGroup>
                                {loadingSearch && (
                                  <div className="d-flex justify-content-center align-items-center mb-5">
                                    <div className="spinner spinner-primary mr-10"></div>
                                  </div>
                                )}
                                {errorSearch && (
                                  <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                      Restless user is a required field
                                    </div>
                                  </div>
                                )}
                                {errors.restlessUserSearch ? (
                                  <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                      {errors.restlessUserSearch}
                                    </div>
                                  </div>
                                ) : null}
                                {writingSearch &&
                                suggestedPeople?.length > 0 &&
                                !errorSearch ? (
                                  <div>{userSuggestions}</div>
                                ) : null}
                              </Form.Group>
                            )}
                          </Form.Group>
                          <Form.Group controlId="formCategory">
                            <Form.Label>Category</Form.Label>
                            <Form.Control
                              as="select"
                              name="category"
                              defaultValue
                              onChange={handleChange}
                              value={values.category}
                              {...getFieldProps("category")}
                            >
                              {!values.category && (
                                <option>Select a category</option>
                              )}
                              {categoriesList.map((category) => (
                                <option key={category.id} value={category.id}>
                                  {category.name}
                                </option>
                              ))}
                            </Form.Control>
                            {touched.category && errors.category ? (
                              <div className="fv-plugins-message-container">
                                <div className="fv-help-block">
                                  {errors.category}
                                </div>
                              </div>
                            ) : null}
                          </Form.Group>
                          <Form.Group controlId="formFeaturedImage">
                            <Form.Label>Lead Image</Form.Label>
                            <Form.File
                              type="file"
                              onChange={handleFileInput}
                              name="featuredImage"
                              label="Lead image"
                              custom
                            />
                            {featuredImage && showImageLeadImage(featuredImage)}
                            {featuredImageError === "empty" ||
                            errors.featuredImage ? (
                              <div className="fv-plugins-message-container">
                                <div className="fv-help-block">
                                  Lead image is a required field
                                </div>
                              </div>
                            ) : null}
                            {featuredImageError === "format" ||
                            errors.featuredImage ? (
                              <div className="fv-plugins-message-container">
                                <div className="fv-help-block">
                                  Wrong format, only: JPEG, JPG and PNG
                                </div>
                              </div>
                            ) : null}
                          </Form.Group>
                          <Form.Group controlId="formMediaContent">
                            <Form.Label>Media</Form.Label>
                            <Form.Control
                              as="select"
                              name="mediaContent"
                              disabled={articleGet && articleGet?.poll}
                              defaultValue
                              onChange={handleChange}
                              value={values.mediaContent}
                              {...getFieldProps("mediaContent")}
                            >
                              {mediaType.map((media, index) => {
                                if (
                                  articleGet &&
                                  !articleGet.poll &&
                                  media !== "Poll"
                                ) {
                                  return (
                                    <option key={index} value={media}>
                                      {media}
                                    </option>
                                  );
                                }
                                if (!articleGet) {
                                  return (
                                    <option key={index} value={media}>
                                      {media}
                                    </option>
                                  );
                                }
                                if (
                                  articleGet &&
                                  articleGet.poll &&
                                  media == "Poll"
                                ) {
                                  return (
                                    <option key={index} value={media}>
                                      {media}
                                    </option>
                                  );
                                }
                              })}
                            </Form.Control>
                            {touched.mediaContent && errors.mediaContent ? (
                              <div className="fv-plugins-message-container">
                                <div className="fv-help-block">
                                  {errors.category}
                                </div>
                              </div>
                            ) : null}
                            <span className="mb-2">
                              Only one media type allowed per resource
                            </span>
                          </Form.Group>
                          {values.mediaContent === "Gif" && !extraGif && (
                            <div className="d-flex justify-content-center">
                              <Button
                                onClick={articlesUIEvents.openSelecGifDialog}
                              >
                                Select Gif
                              </Button>
                            </div>
                          )}
                          {extraGif && (
                            <>
                              <div className="d-flex justify-content-center align-content-center align-self-center align-items-center mt-5 ml-5 mr-5 mb-5">
                                <img
                                  className="d-flex justify-content-center align-content-center align-self-center"
                                  src={extraGif.url}
                                  width={200}
                                />
                              </div>
                              <div className="d-flex justify-content-center">
                                <Button onClick={() => onDeleteGif()}>
                                  Remove Gif
                                </Button>
                              </div>
                            </>
                          )}
                          {values.mediaContent == "Images" && (
                            <Form.Group controlId="formExtraImage">
                              <Form.Label>
                                Attach an image {extraImage?.length}/10
                              </Form.Label>
                              <Form.File
                                type="file"
                                name="extraImage"
                                onChange={onExtraImageChange}
                                label="Select an image"
                                custom
                                className="mb-0"
                              />
                              <small className="mt-3 d-inline-block text-primary">Images will be displayed in the order they are uploaded</small>
                              {extraImage?.length > 0 &&
                                showImagePreview(extraImage)}
                            </Form.Group>
                          )}
                          {values.mediaContent == "Video" && (
                            <Form.Group controlId="formExtraVideo">
                              <Form.Label>Attach a video</Form.Label>
                              <Form.File
                                type="file"
                                name="extraVideo"
                                onChange={onExtraVideoChange}
                                label="Select a video"
                                custom
                              />
                            </Form.Group>
                          )}
                          {extraVideo && showVideoPreview(extraVideo)}
                          {values.mediaContent == "Poll" && (
                            <>
                              <div className="d-flex justify-content-center mb-2">
                                <div className="mr-2">
                                  <Button
                                    onClick={
                                      articlesUIEvents.openPollCreatorDialog
                                    }
                                  >
                                    {!poll && !fetchedPoll
                                      ? "Create Poll"
                                      : "Edit Poll"}
                                  </Button>
                                </div>
                                <div>
                                  {poll && !fetchedPoll && (
                                    <Button onClick={() => {                                                                            
                                      dispatch(actions.articleRemovePoll());
                                    }}>
                                      Remove Poll
                                    </Button>
                                  )}
                                </div>
                              </div>
                              <div className="mt-4 d-flex justify-content-center">
                                {poll ? (
                                  <div>{poll.body}</div>
                                ) : fetchedPoll ? (
                                  <div>{fetchedPoll.body}</div>
                                ) : null}
                              </div>
                            </>
                          )}
                        </Card.Body>
                      </Card>
                    </div>
                  </div>
                </Form>
              )}
            </>
          );
        }}
      </Formik>
    </>
  );
}
